"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Camera = void 0;
var three_1 = require("three");
var OrbitControls_js_1 = require("three/examples/jsm/controls/OrbitControls.js");
var Camera = /** @class */ (function () {
    function Camera(base) {
        this.base = base;
        this.bestPoint = new three_1.Vector3(-8, 1, 8);
        this.minimunDrawbackAngle = Math.PI / 3;
        this.sizer = this.base.sizer;
        this.canvas = this.base.domCanvas;
        this.scene = this.base.scene;
        this.setInstance();
        this.setControls();
    }
    Camera.prototype.setInstance = function () {
        var camera = new three_1.PerspectiveCamera(35, this.sizer.width / this.sizer.height, 0.1, 100);
        camera.position.set(this.bestPoint.x, this.bestPoint.y, this.bestPoint.z);
        this.instance = camera;
        this.scene.add(this.instance);
        // //@ts-ignore
        // window.cm = camera;
    };
    Camera.prototype.setControls = function () {
        this.controls = new OrbitControls_js_1.OrbitControls(this.instance, this.canvas);
        this.controls.enableDamping = true;
        this.controls.enableZoom = false;
        this.controls.enablePan = false;
    };
    Camera.prototype.resize = function () {
        this.instance.aspect = this.sizer.width / this.sizer.height;
        this.instance.updateProjectionMatrix();
    };
    Camera.prototype.update = function () {
        this.controls.update();
    };
    return Camera;
}());
exports.Camera = Camera;
